/* src/app/shared/shop/product-card/product-price/product-price.component.scss */
.container-price {
  flex-wrap: wrap;
  align-items: baseline;
  gap: 5px;
}
.container-price span {
  font-family: "League Spartan", sans-serif;
  font-size: 18px;
  white-space: nowrap;
}
.small-text {
  font-weight: 600 !important;
  font-size: 16px !important;
}
.line-middle {
  -webkit-text-decoration-line: line-through;
  text-decoration-line: line-through;
}
.discount {
  color: #949494;
  gap: 15px;
}
.discount-label {
  font-family: Barlow Semi Condensed;
  font-size: 14px !important;
  font-weight: 500 !important;
  line-height: 16.8px !important;
  color: #c80064;
  background-color: #ffd5eb;
  border-radius: 20px;
  padding: 8px 16px 8px 16px;
}
.finalPrice {
  font-family: League Spartan;
  font-size: 22px !important;
  font-weight: 600 !important;
  line-height: 26.4px !important;
  color: #363842 !important;
}
@media (max-width: 1104px) {
  .finalPrice {
    font-size: 20px !important;
    line-height: 24px !important;
  }
}
/*# sourceMappingURL=product-price.component-HLFAUSXF.css.map */
